import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

import {
  faChevronRight,
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../StyleSheets/Footer.css";
import { useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { submitContactQuery } from "../Redux/Reducers/ContactSlice";
import { useAuthNavigation } from "./Utils/useAuthNavigation";
import { useAuth } from "./Routes/AuthContext";
import credential from "../API/Credentials.json";
import StaticData from "../Static/StaticData.json";
const { Footer_Text } = StaticData;
const { Footer_Col_1, Footer_Col_2, Footer_Col_3 } = Footer_Text;
const {
  Footer_Col_1_Title,
  Footer_Col_1_Description,
  Footer_Col_1_Address,
  Footer_Col_1_Mail,
  Footer_Col_1_Phone,
} = Footer_Col_1;

const { Footer_Col_2_Title } = Footer_Col_2;
const {
  Footer_Col_3_Title,
  Footer_Col_3_Query_Form_Button,
  Footer_Form_Field,
  Footer_SweetAlert_Error,
  Footer_SweetAlert_Success,
  Sending,
} = Footer_Col_3;
const {
  Footer_Field_Name,
  Footer_Field_Email,
  Footer_Field_Message,
  Footer_Placeholder_Name,
  Footer_Placeholder_Email,
  Footer_Placeholder_Message,
} = Footer_Form_Field;
const {
  Footer_Error_Icon,
  Footer_Error_Title,
  Footer_Error_Text,
  Footer_Error_Something_Title,
} = Footer_SweetAlert_Error;
const { Footer_Success_Icon, Footer_Success_Title, Footer_Success_Text } =
  Footer_SweetAlert_Success;

// Footer  Text and Icon Component
const WebIconTextRow = ({ icon, text }) => (
  <Row>
    <Col className="pt-1">
      <div className="d-flex ">
        <span>
          <FontAwesomeIcon
            icon={icon}
            color="#3dd5f3"
            style={{ paddingRight: "8px" }}
            className="fa-xs"
          />
        </span>
        <span className="email-text">{text}</span>
      </div>
    </Col>
  </Row>
);

// Contact Component [Column I] call in WebFooter Component
const WebFooterContact = () => {
  const webIconTextRowArr = [
    { icon: faLocationDot, text: Footer_Col_1_Address },
    { icon: faEnvelope, text: Footer_Col_1_Mail },
    { icon: faPhone, text: Footer_Col_1_Phone },
  ];
  return (
    <Col md={4} sm={12} className="mb-4">
      <Row className="w-footer-title ">
        <h1>{Footer_Col_1_Title}</h1>
        <div className="underlineBox-1">
          <div className="underline"></div>
        </div>
      </Row>
      <Row>
        <p>{Footer_Col_1_Description}</p>
        {webIconTextRowArr &&
          webIconTextRowArr.map((item, index) => {
            return (
              <WebIconTextRow key={index} icon={item.icon} text={item.text} />
            );
          })}
      </Row>
    </Col>
  );
};

// Feature List Component
const WebFooterFeatureList = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { navigateWithAuth } = useAuthNavigation();
  const featurePaths = [
    "/dashboard/health-analysis/diabetes-analysis",
    "/dashboard/health-analysis/asthma-analysis",
    "/dashboard/health-analysis/cardiovascular-analysis",
    "/dashboard/health-analysis/heartstrokes-analysis",
    "/dashboard/health-analysis/livercondition-analysis",
    "/dashboard/health-analysis/alzheimer-analysis",
    "/dashboard/health-analysis/cancer-analysis",
    "/dashboard/health-analysis/chronic-kidney-analysis",
    "/dashboard/health-analysis/hypertension-analysis",
    "/dashboard/health-analysis/osteoporosis-analysis",
    "/dashboard/health-analysis/pancreatic-analysis",
  ];

  return (
    <Col
      md={4}
      sm={13}
      className="w-footer mb-4"
      style={{ minHeight: "340px" }}
    >
      <Row className="w-footer-title">
        <h1>{Footer_Col_2_Title}</h1>
        <div className="underlineBox-2">
          <div className="underline"></div>
        </div>
      </Row>
      <Row>
        <ul>
          {Object.keys(Footer_Col_2)
            .filter((key) => key.startsWith("Footer_Col_2_Feature"))
            .map((key, index) => (
              <li key={key}>
                <div
                  className="w-footer-link"
                  onClick={() => {
                    if (isAuthenticated) {
                      navigate(featurePaths[index]);
                    } else {
                      navigateWithAuth("/login");
                    }
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <FontAwesomeIcon
                    className="fa-xs"
                    icon={faChevronRight}
                    style={{ paddingRight: "5px", color: "#3dd5f3" }}
                  />
                  {Footer_Col_2[key]}
                </div>
              </li>
            ))}
        </ul>
      </Row>
    </Col>
  );
};

// Enquiry Form Component [Coulumn III] Call in WebFooter Component
const WebFooterEnquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const dispatch = useDispatch();
  const { loading, errors } = useSelector((state) => state.contact);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;

    if (!name || !email || !message) {
      Swal.fire({
        icon: Footer_Error_Icon,
        title: Footer_Error_Title,
        text: Footer_Error_Text,
        customClass: {
          confirmButton: "btn-blue",
        },
      });
      setFormData({ name: "", email: "", message: "" });
      return;
    }

    const bodyData = credential?.Query_API?.body;
    const apiData = {
      ...bodyData,
      data: {
        name: name,
        email: email,
        query: message,
      },
    };

    const response = dispatch(submitContactQuery({ apiData }));
    if (response) {
      Swal.fire({
        icon: Footer_Success_Icon,
        title: Footer_Success_Title,
        text: Footer_Success_Text,
        customClass: {
          confirmButton: "btn-blue",
        },
      });
      setFormData({ name: "", email: "", message: "" });
    } else {
      Swal.fire({
        icon: Footer_Error_Icon,
        title: Footer_Error_Something_Title,
        text: errors,
        customClass: {
          confirmButton: "btn-blue",
        },
      });
    }
  };

  return (
    <>
      <Col sm={12} lg={4} md={7} className="mb-4 ">
        <Row className="w-footer-title ">
          <h1>{Footer_Col_3_Title}</h1>
          <div className="underlineBox-3">
            <div className="underline"></div>
          </div>
        </Row>
        <div className="enquiry-form-row">
          {[
            Footer_Placeholder_Name,
            Footer_Placeholder_Email,
            Footer_Placeholder_Message,
          ].map((placeholder, index) => (
            <Row className={`${index === 0 ? "mt-auto" : "mt-2"}`} key={index}>
              <Form.Control
                style={{
                  padding: "10px",
                  ...(placeholder === Footer_Placeholder_Message && {
                    height: "70px",
                    maxHeight: "80px",
                    resize: "none",
                  }),
                  '::placeholder': { color: "#666" }
                }}
                type={
                  placeholder === Footer_Placeholder_Email
                    ? Footer_Field_Email
                    : "text"
                }
                as={
                  placeholder === Footer_Placeholder_Message
                    ? "textarea"
                    : "input"
                }
                placeholder={placeholder}
                name={
                  placeholder === Footer_Placeholder_Email
                    ? Footer_Field_Email
                    : placeholder === Footer_Placeholder_Name
                      ? Footer_Field_Name
                      : Footer_Field_Message
                }
                value={
                  formData[
                  placeholder === Footer_Placeholder_Email
                    ? Footer_Field_Email
                    : placeholder === Footer_Placeholder_Name
                      ? Footer_Field_Name
                      : Footer_Field_Message
                  ]
                }
                onChange={handleChange}
              />
            </Row>
          ))}
          <Row sm={1} xxl={3} className=" mt-2 d-flex justify-content-center">
            <Button
              className={
                loading
                  ? "w-footer-form-button bg-black"
                  : "w-footer-form-button"
              }
              variant="outline-info"
              onClick={handleSubmit}
              disabled={loading ? true : false}
            >
              {loading ? Sending : Footer_Col_3_Query_Form_Button}
            </Button>
          </Row>
        </div>
      </Col>
    </>
  );
};

//  Footer WebFooter Social Media Strip Component call in bottom of footer file[Main]
const WebFooterSocial = () => {
  const socialIcons = [
    faFacebook,
    faTwitter,
    faLinkedin,
    faInstagram,
    faEnvelope,
  ];

  return (
    <>
      <Row className="horizontal-line justify-content-center px-4">
        <hr style={{ width: "100%", padding: "0px 20px" }} />
      </Row>
      <Row className="w-footer-copyright">
        <h6>{Footer_Text.Footer_Copyright.Footer_Copyright_Title}</h6>
      </Row>
      <Row className="w-footer-icons">
        {socialIcons.map((icon, index) => (
          <SocialMediaIcon key={index} icon={icon} />
        ))}
      </Row>
    </>
  );
};

// Legal Links Component
const WebFooterLegalLinks = () => {
  const navigate = useNavigate();

  return (
    <Row className="w-footer-legal-links justify-content-center px-4 py-3">
      <div className="legal-links-container">
        <Link to="/privacy-policy" className="legal-link">
          Privacy Policy
        </Link>
        <span className="link-separator">|</span>
        <Link to="/terms-of-service" className="legal-link">
          Terms of Service
        </Link>
      </div>
    </Row>
  );
};

// Footer component All column footer part in this component  and call in Footer component.
const WebFooter = () => {
  const matches_1120 = useMediaQuery("(min-width:1120px)");
  return (
    <>
      {
        <footer className="w-footer bg-black text-light p-3">
          {matches_1120 ? (
            <Container className="w-footer-container">
              <Row className="px-3">
                <WebFooterContact />
                <WebFooterFeatureList />
                <WebFooterEnquiry />
              </Row>

              <WebFooterSocial />
              <WebFooterLegalLinks />
            </Container>      
          ) : (
            <div className="w-footer-container">
              <div className="mobile-w-footer">
                <WebFooterContact />
                <WebFooterFeatureList />
                <WebFooterEnquiry /> 
              </div>

              <WebFooterSocial />
              <WebFooterLegalLinks />
            </div>
          )}
        </footer>
      }
    </>
  );
};

// Social Media Icons Component
const SocialMediaIcon = ({ icon }) => (
  <Col className="col-1 mx-1">
    <FontAwesomeIcon icon={icon} color="#3dd5f3" size="1x" />
  </Col>
);

// Footer Component [Main]
const Footer = () => {
  const location = useLocation();
  const allowedPaths = ["/", "/about", "/contact", "/privacy-policy", "/terms-of-service"];
  const showFooter = allowedPaths.includes(location.pathname);
  return showFooter ? <WebFooter /> : null;
};

export default Footer;
